import script from "./editPop.vue?vue&type=script&setup=true&lang=js"
export * from "./editPop.vue?vue&type=script&setup=true&lang=js"

import "./editPop.vue?vue&type=style&index=0&id=c77576ec&lang=less&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c77576ec"]])

export default __exports__